export default __webpack_public_path__ + "static/media/logo_new_blue.5d8a4343.svg";